import { apiErrorCode, fmtBkk, isSchemaMissing } from "@/utils/marketing";
import swal from "sweetalert2";
import { money } from "@/utils/affiliate";

// Shared bits of the Phase 3 affiliate pages (spec 2026-10-13 §5): error
// notification by contract code, date / money display.
export default {
    methods: {
        fmt: fmtBkk,
        money,
        // $t(prefix + suffix) for the flat spec keys (`…status_` + "paid"): the
        // suffix sets are pinned in tests/unit/affiliateWiring.spec.js.
        tk(prefix, suffix) {
            return this.$t(prefix + suffix);
        },
        dateOnly(iso) {
            return iso ? fmtBkk(iso).slice(0, 10) : "-";
        },
        errText(err) {
            if (isSchemaMissing(err)) return this.$t("marketing.schema_missing");
            const code = apiErrorCode(err);
            if (code && this.$te("marketing.affiliate.err." + code)) return this.$t("marketing.affiliate.err." + code);
            return this.$t("marketing.affiliate.err.generic");
        },
        showError(err) {
            this.$notify({ type: "danger", message: this.errText(err) });
        },
        notifyOk(key) {
            this.$notify({ type: "success", message: this.$t(key || "marketing.affiliate.saved") });
        },
        // { data: X } envelope → X
        unwrap(res) {
            const b = (res && res.data) || {};
            return b.data !== undefined ? b.data : b;
        },
        // swal with a required reason (1–300 chars); null when dismissed.
        async askReason(title, opts = {}) {
            const r = await swal.fire({
                title,
                text: opts.text || "",
                input: "textarea",
                inputPlaceholder: opts.label || this.$t("marketing.affiliate.reason"),
                showCancelButton: true,
                reverseButtons: true,
                confirmButtonText: opts.confirm || this.$t("marketing.affiliate.confirm"),
                cancelButtonText: this.$t("marketing.affiliate.cancel"),
                confirmButtonColor: opts.danger ? "#d33" : undefined,
                cancelButtonColor: "#6c757d",
                inputValidator: (v) => {
                    const s = String(v || "").trim();
                    if (!s) return this.$t("marketing.affiliate.reason_required");
                    if (s.length > 300) return this.$t("marketing.affiliate.reason_too_long");
                    return null;
                }
            });
            return r && r.value ? String(r.value).trim() : null;
        },
        // Plain yes/no swal; true when confirmed.
        async confirmBox(text, opts = {}) {
            const r = await swal.fire({
                title: opts.title || "",
                text,
                icon: opts.icon || "warning",
                showCancelButton: true,
                reverseButtons: true,
                focusCancel: true,
                confirmButtonText: opts.confirm || this.$t("marketing.affiliate.confirm"),
                cancelButtonText: this.$t("marketing.affiliate.cancel"),
                confirmButtonColor: opts.danger ? "#d33" : undefined,
                cancelButtonColor: "#6c757d"
            });
            return !!(r && r.value);
        }
    }
};
